import React, { Component } from 'react';
import { Button, ButtonToolbar, Table, Col, Grid } from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import { ZoneForm } from './ZoneForm';
import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { ZoneAPI } from '../../../api/datamanager/ZoneAPI';
import { ZoneTypeAPI } from '../../../api/datamanager/ZoneTypeAPI';
import { ProviderFareAPI } from '../../../api/datamanager/ProviderFareAPI';
import { LoadingSpinner } from '../../LoadingSpinner';
import { PaginationBuilder } from '../../PaginationBuilder';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { SearchHelper } from '../../helpers/SearchHelper';
import { SearchBar } from '../../SearchBar';
import { TitleRow } from '../../TitleRow';
import { TableButton } from '../../TableButton';

export class Zones extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string
    }

    constructor(props) {
        super(props);
        this.state = {
            zones: [],
            providerFares: [],
            zoneTypes: [],
            zoneSelected: undefined,
            showZoneFormModal: false,
            showDeleteModal: false,
            showExecutingModal: false,
            filter: "",
            nameInputError: null,
            zoneTypeInputError: null,
            title: '',
            alertTitle: undefined,
            icon: undefined,
            alertMessage: undefined,
            alertStyle: undefined,
            executingMessage: <LoadingSpinner />,
            executingStyle: "primary",
            exectuingIcon: "transfer",
            executingTitle: "A Executar...",
            currentPage: 1,
            elementsPerPage: 10,
            errorLoading: false,
            loading: true
        }
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);

        this.getZones();
        this.getZoneTypes();
        this.getProviderFares();
    }

    getZones() {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        let zoneSelectedId = typeof this.state.zoneSelected !== 'undefined' ? this.state.zoneSelected.id : undefined;

        ZoneAPI.list(selectedProviderId)
            .then(response => JSON.parse(response))
            .then(data => {
                const totalPages = PaginationHelper.getTotalPages(data.length, this.state.elementsPerPage);
                this.setState({
                    zones: data,
                    currentPage: this.state.currentPage > totalPages ? totalPages : this.state.currentPage,
                    zoneSelected: typeof zoneSelectedId !== 'undefined' ? data.filter(zone => zone.id === zoneSelectedId)[0] : undefined,
                    nameInputError: null,
                    zoneTypeInputError: null,
                    showZoneFormModal: false,
                    showExecutingModal: false,
                    showDeleteModal: false,
                    loading: false
                });
            }).catch((err) => {
                this.setState({
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true,
                    showExecutingModal: false,
                    errorLoading: true
                })
            });
    }

    getProviderFares() {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        ProviderFareAPI.list(selectedProviderId)
            .then(response => JSON.parse(response))
            .then(data => {
                this.setState({
                    providerFares: data
                });
            }).catch((err) => {
                this.setState({
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true,
                    showExecutingModal: false,
                    errorLoading: true
                })
            });
    }

    getZoneTypes() {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        let zoneTypeSelectedId = typeof this.state.zoneTypeSelected !== 'undefined' ? this.state.zoneTypeSelected.id : undefined;

        ZoneTypeAPI.list(selectedProviderId)
            .then(response => JSON.parse(response))
            .then(data => {
                this.setState({
                    zoneTypes: data,
                    zoneTypeSelected: typeof zoneTypeSelectedId !== 'undefined' ? data.filter(zoneType => zoneType.id === zoneTypeSelectedId)[0] : undefined,
                });
            }).catch((err) => {
                this.setState({
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true,
                    showExecutingModal: false,
                    errorLoading: true
                })
            });
    }

    handleCreateClick = () => {
        let { zoneTypes } = this.state;
        this.setState({
            zoneSelected: {
                fareZone: {
                    name: '', fare: { id: 0 }
                },
                zoneType: zoneTypes.length !== 0 ? zoneTypes[0] : undefined
            },
            showZoneFormModal: true,
            showErrorModal: false,
            title: 'Criar'
        })
    }

    handleEditClick = (zone) => {
        this.setState({
            zoneSelected: zone,
            showZoneFormModal: true,
            title: 'Editar'
        })

    }

    handleDeleteClick = (zone) => {
        this.setState({
            zoneSelected: zone,
            showDeleteModal: true,
            alertTitle: "Aviso",
            alertMessage: `Tem a certeza que pretende eliminar a zona ${zone.fareZone.name}?`,
            alertStyle: "warning",
            icon: 'alert'
        })
    }

    updateZoneValue = (e, value) => {
        let { zoneSelected, zoneTypes, providerFares } = this.state;

        if (value === 'fare') {
            if (e.target.value === 'Sem Tarifário') {
                zoneSelected.fareZone.fare = {}
            } else {
                var auxFare = providerFares.filter(pFare => pFare.fare.id === parseInt(e.target.value, 10))[0];
                zoneSelected.fareZone.fare = auxFare.fare;
            }
        } else if (value === 'zoneType') {
            zoneSelected.zoneType = zoneTypes.filter(zoneType => zoneType.id === parseInt(e.target.value, 10))[0];
        }
        else {
            zoneSelected.fareZone[value] = e.target.value;
        }

        this.setState({
            zoneSelected
        })
    }

    saveZone = () => {
        if (this.state.zoneSelected.id !== undefined) {
            if (this.validInput()) {
                this.setState({
                    showExecutingModal: true
                }, () => {
                    ZoneAPI.update(this.state.zoneSelected.id, this.state.zoneSelected)
                        .then(() => {
                            this.setState({
                                showExecutingModal: false,
                                alertTitle: "Sucesso",
                                alertMessage: 'Zona alterada com sucesso.',
                                alertStyle: 'success',
                                icon: 'ok',
                                showErrorModal: true
                            })
                            this.getZones()
                        }).catch((err) => {
                            this.setState({
                                showExecutingModal: false,
                                alertTitle: "Erro",
                                alertMessage: err.message,
                                alertStyle: 'danger',
                                icon: 'remove',
                                showErrorModal: true
                            })
                            this.getZones()
                        })
                })
            }
        } else {
            if (this.validInput()) {
                this.setState({
                    showExecutingModal: true
                }, () => {
                    ZoneAPI.create(this.state.zoneSelected)
                        .then(() => {
                            this.setState({
                                showExecutingModal: false,
                                alertTitle: "Sucesso",
                                alertMessage: 'Zona criada com sucesso.',
                                alertStyle: 'success',
                                icon: 'ok',
                                showErrorModal: true
                            })
                            this.getZones()
                        }).catch((err) => {
                            this.setState({
                                showExecutingModal: false,
                                alertTitle: "Erro",
                                alertMessage: err.message,
                                alertStyle: 'danger',
                                icon: 'remove',
                                showErrorModal: true
                            })
                            this.getZones()
                        })
                })
            }
        }
    }

    deleteZone = (isToExecute) => {
        if (isToExecute) {
            this.setState({
                showDeleteModal: false,
                showExecutingModal: true
            }, () => {
                ZoneAPI.delete(this.state.zoneSelected.id)
                    .then(() => {
                        this.setState({
                            showExecutingModal: false,
                            alertTitle: "Sucesso",
                            alertMessage: 'Zona removida com sucesso.',
                            alertStyle: 'success',
                            icon: 'ok',
                            showErrorModal: true
                        })
                        this.getZones()
                    }).catch((err) => {
                        this.setState({
                            showExecutingModal: false,
                            alertTitle: "Erro",
                            alertMessage: err.message,
                            alertStyle: 'danger',
                            icon: 'remove',
                            showErrorModal: true
                        })
                        this.getZones()
                    })
            })
        }

        this.setState({
            showDeleteModal: false
        })
    }

    validInput() {
        let { nameInputError, zoneTypeInputError } = this.state;
        let errors = 0;

        zoneTypeInputError = null;
        nameInputError = null;

        if (this.state.zoneSelected.fareZone.name === "") {
            nameInputError = 'error';
            errors++;
        }

        if (this.state.zoneSelected.zoneType === undefined) {
            zoneTypeInputError = 'error';
            errors++;
        }

        this.setState({
            nameInputError,
            zoneTypeInputError
        })

        return errors > 0 ? false : true;
    }

    clearError = () => {
        this.setState({
            alertTitle: undefined,
            alertMessage: undefined,
            alertStyle: undefined,
            icon: undefined,
            showErrorModal: false
        })
    }

    onChangePage = (page) => {
        this.setState({
            currentPage: page
        });
    }

    onChangeElementsPerPage = (elements) => {
        this.setState({
            elementsPerPage: elements
        });
    }

    onSearch(filter) {
        this.setState({
            filter: filter
        });
    }

    renderZonesTable(zones) {
        const { currentPage, elementsPerPage, filter } = this.state;

        const zonesFiltered = SearchHelper.search({
            filter: filter, 
            data: zones, 
            fields: ["fareZone.name", "zoneType.name", "fareZone.fare.name"]
        });
        const totalPages = PaginationHelper.getTotalPages(zonesFiltered.length, elementsPerPage);
        const activePage = totalPages < currentPage ? totalPages : currentPage;
        const zonesToRender = zonesFiltered.sort((a, b) => a.fareZone.name.toUpperCase() !== b.fareZone.name.toUpperCase() ? a.fareZone.name.toUpperCase() < b.fareZone.name.toUpperCase() ? -1 : 1 : 0)
            .slice((activePage - 1) * elementsPerPage, activePage * elementsPerPage);

        return (
            <Grid fluid className="table-small-screens">
                <Table responsive striped hover >
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Tipo de Zona</th>
                            <th>Tarifário</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            zonesToRender.map((zone, idx) =>
                                <tr key={`zone-${idx}`}>
                                    <td>{zone.fareZone.name}</td>
                                    <td>{zone.zoneType.name}</td>
                                    <td>{zone.fareZone.fare !== undefined ? zone.fareZone.fare.name : ''}</td>
                                    <td>
                                        <ButtonToolbar className="pull-right">
                                            <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.handleEditClick(zone)} />
                                            <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.handleDeleteClick(zone)} />
                                        </ButtonToolbar>
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table >
                <PaginationBuilder currentPage={currentPage} 
                    elementsPerPage={elementsPerPage} 
                    dataLength={zonesFiltered.length} 
                    onChangePage={this.onChangePage}
                    onChangeElementsPerPage={this.onChangeElementsPerPage} />
            </Grid>
        );
    }

    render() {
        if (!this.state.errorLoading) {
            let contents = this.state.loading
                ? <LoadingSpinner />
                : this.renderZonesTable(this.state.zones);

            return (
                <div>
                    {this.state.loading
                        ?
                        null
                        :
                        <TitleRow title="Zonas" showSeparator={true}>
                            <Col className="padding-0" xs={2} sm={1} md={4}>
                                <ButtonToolbar className="pull-right title-row-col-btns">
                                    <Button onClick={this.handleCreateClick}>CRIAR</Button>
                                </ButtonToolbar>
                            </Col>
                            <Col className="padding-0" xs={10} sm={11} md={8}>
                                <div className="search-bar">
                                    <SearchBar onSearch={(a) => this.onSearch(a)} />
                                </div>
                            </Col>
                        </TitleRow>
                    }

                    <div className="margin-top-15">
                        {contents}
                    </div>

                    <ZoneForm show={this.state.showZoneFormModal} zone={this.state.zoneSelected} providerFares={this.state.providerFares} zoneTypes={this.state.zoneTypes} nameInputError={this.state.nameInputError}
                        zoneTypeInputError={this.state.zoneTypeInputError} onHide={() => this.getZones()} onChangeValue={this.updateZoneValue} onSave={this.saveZone} title={this.state.title} />
                    <HandleDialog show={this.state.showDeleteModal} title={this.state.alertTitle} message={this.state.alertMessage} icon={this.state.icon} style={this.state.alertStyle} onExit={this.deleteZone} />
                    <HandleMessage title={this.state.alertTitle} message={this.state.alertMessage} icon={this.state.icon} style={this.state.alertStyle} show={this.state.showErrorModal} onHide={this.clearError} />
                    <HandleMessage show={this.state.showExecutingModal} title={this.state.executingTitle} message={this.state.executingMessage} icon={this.state.exectuingIcon} style={this.state.executingStyle}
                        onHide={this.clearError} small noButtons />
                </div>
            );
        } else {
            return (
                <div>
                    <LoadingSpinner />
                    <HandleMessage title={this.state.alertTitle} message={this.state.alertMessage} icon={this.state.icon} style={this.state.alertStyle} show={this.state.showErrorModal} onHide={this.clearError} />
                </div>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/zones/Zones.js